import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Mobile from "../component/container/Mobile";
class Approuter extends React.Component {
    render() {
        return (
            <Router>
                <Route path="/cars" />
                <Route path="/mobile" component={Mobile} />
            </Router>
        );
    }
}

export default Approuter;
